import type { Block } from '@contentful/rich-text-types'
import { clsx } from 'clsx'
import type { ReactElement, ReactNode } from 'react'

import styles from './rich-text.module.scss'

interface UlListProps extends Block {
  children?: ReactNode
}

export function UlList(props: UlListProps): ReactElement {
  return <ul className={clsx(styles.list, styles.ulList)}>{props.children}</ul>
}
